

export class RoutePathRoutPathGroupOutput implements IRoutePathRoutPathGroupOutput {
    /** The auto-generated id of the allocated route path master */
    allocated_route_path_id!: number;
    /** The auto-generated id of the route path master */
    route_path_id!: number;

    constructor(data?: IRoutePathRoutPathGroupOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allocated_route_path_id = _data["allocated_route_path_id"];
            this.route_path_id = _data["route_path_id"];
        }
    }

    static fromJS(data: any): RoutePathRoutPathGroupOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RoutePathRoutPathGroupOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allocated_route_path_id"] = this.allocated_route_path_id;
        data["route_path_id"] = this.route_path_id;
        return data; 
    }
}

export interface IRoutePathRoutPathGroupOutput {
    /** The auto-generated id of the allocated route path master */
    allocated_route_path_id: number;
    /** The auto-generated id of the route path master */
    route_path_id: number;
}

